import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Calculator } from './Calculators'

import TotalsPanel from './Widgets/TotalsPanel'

import * as residential from './Residential'
import * as commercial from './Commercial'

const allSections = {
  residential,
  commercial,
}

const preventDefault = (func) => (e, ...args) => {
  e.preventDefault()
  func(...args)
}

export default class Form extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(Calculator).isRequired,
    data: PropTypes.object.isRequired,
    gotoNextStage: PropTypes.func.isRequired,
    gotoPreviousStage: PropTypes.func.isRequired,
    gotoStage: PropTypes.func.isRequired,
    mode: PropTypes.string.isRequired,
    stage: PropTypes.number.isRequired,
    updateField: PropTypes.func.isRequired,
    updateUnit: PropTypes.func.isRequired,
  }

  render() {
    const {
      calculator,
      data,
      gotoNextStage,
      gotoPreviousStage,
      gotoStage,
      mode,
      stage,
      updateField,
      updateUnit,
    } = this.props

    const sections = allSections[mode]

    const formProps = { calculator, data, updateField, updateUnit }

    let form = null

    switch (stage) {
      case 1:
        form = <sections.GrossDevelopmentValueForm {...formProps} />
        break;
      case 2:
        form = <sections.BuildingAndMarketingCost {...formProps} />
        break;
      case 3:
        form = <sections.LandResidualPrice {...formProps} />
        break;
      case 4:
        form = <sections.Summary {...formProps} gotoStage={gotoStage} />
        break;
      default:
    }

    return (
      <form noValidate onSubmit={preventDefault(gotoNextStage)}>
        <div className='calculator-layout'>
          <div className='calculator-layout__main' key={`${mode}-${stage}`}>
            {form}

            {stage < 4 && (
              <div className='calculator-layout__actions hidden-mobile hidden-tablet'>
                <button
                  className='btn btn--outline btn--primary btn--white-bg'
                  onClick={gotoNextStage}
                  type='button'
                >
                  {stage === 3 ? 'View full calculation' : 'Next stage'}
                </button>
                {stage > 1 && (
                  <button
                    className='btn btn--link btn--underline'
                    onClick={gotoPreviousStage}
                    type='button'
                  >
                    Back
                  </button>
                )}
              </div>
            )}
          </div>
          <div className='calculator-layout__side'>
            <TotalsPanel
              buildingCosts={calculator.format(calculator.getBuildingCosts())}
              grossDevelopmentValue={calculator.format(calculator.getGrossDevelopmentValue())}
              totalCosts={calculator.format(calculator.getTotalCosts())}
              totalProfit={calculator.format(calculator.getDeveloperProfitTotal())}
              landValue={calculator.format(calculator.getLandValue())}
              landValuePerUnitArea={calculator.format(calculator.getLandValuePerUnitArea(true))}
              showEditButtons={stage === 4}
              gotoStage={gotoStage}
              stage={stage}
              unit={data.unit}
              updateUnit={updateUnit}
            />
          </div>
        </div>
        {stage < 4 && (
          <div className='calculator-layout__actions hidden-laptop hidden-desktop'>
            <button
              className='btn btn--outline btn--primary btn--white-bg'
              type='submit'
            >
              {stage === 3 ? 'View full calculation' : 'Next stage'}
            </button>
            {stage > 1 && (
              <button
                className='btn btn--link btn--underline'
                onClick={gotoPreviousStage}
                type='button'
              >
                Back
              </button>
            )}
          </div>
        )}
      </form>
    )
  }
}
